import { useContext } from "react";
import { Table } from '../../../components/table/Table';
import Loader from "../../../components/loader/Loader";
import { FeatureContext } from "../../../Context";
import { lang } from "../../../Utils";

const Details = () => {

  const context = useContext(FeatureContext);

  return <div>
    <Table dataSet={context?.details} pagination={true} >
      <Table.Caption>{lang('Details List')}</Table.Caption>
      <Table.Header>
        <Table.Header.Column sortKey={"salesOrderItem"} sortable={true}>{lang('N Line')}</Table.Header.Column>
        <Table.Header.Column sortKey={"bonfiglioliMaterialNumber"} sortable={true}>{lang('Material Code')}</Table.Header.Column>
        <Table.Header.Column sortKey={"customerMaterialNumber"} sortable={true}>{lang('Customer Material Code')}</Table.Header.Column>
        <Table.Header.Column sortKey={"description"} sortable={true}>{lang('Designation')}</Table.Header.Column>
        <Table.Header.Column sortKey={"quantity"} sortable={true}>{lang('Ordered Qty')}</Table.Header.Column>
        <Table.Header.Column sortKey={"qtyconfirmed"} sortable={true}>{lang('Confirmed Qty')}</Table.Header.Column>
        <Table.Header.Column sortKey={"qtyshipped"} sortable={true}>{lang('Shipped Qty')}</Table.Header.Column>
        <Table.Header.Column sortKey={"totalNetPrice"} sortable={true}>{lang('Total Net Price')}</Table.Header.Column>
        <Table.Header.Column sortKey={"status"} sortable={true}>{lang('Status')}</Table.Header.Column>
        <Table.Header.Column sortKey={"statusBilled"} sortable={true}>{lang('Billing')}</Table.Header.Column>
      </Table.Header>
      <Table.Body noDataMessage={lang('No Data available to display')}>
        <Table.Body.Text onClick={context.setDetail} label={lang('N Line')} field="salesOrderItem" />
        <Table.Body.Text onClick={context.setDetail} label={lang('Material Code')} field="bonfiglioliMaterialNumber" />
        <Table.Body.Text onClick={context.setDetail} label={lang('Customer Material Code')} field="customerMaterialNumber" />
        <Table.Body.LongText onClick={context.setDetail} label={lang('Designation')} field="description" />
        <Table.Body.Text onClick={context.setDetail} label={lang('Ordered Qty')} field="quantity" />
        <Table.Body.Text onClick={context.setDetail} label={lang('Confirmed Qty')} field="qtyconfirmed" />
        <Table.Body.Text onClick={context.setDetail} label={lang('Shipped Qty')} field="qtyshipped" />
        <Table.Body.Currency onClick={context.setDetail} label={lang('Total Net Price')} currency="currency" field="totalNetPrice" />
        <Table.Body.Status onClick={context.setDetail} label={lang('Status')} field="status.value" code="status.code" />
        <Table.Body.Status onClick={context.setDetail} label={lang('Billing')} field="statusBilled.value" code="status.code" />
      </Table.Body>
    </Table>
  </div>
}

export default Details;